import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { PopupService } from '../../../../services/popup.service';
import { PropertyService } from '../../../../services/property.service';
import { LoaderService } from '../../../../services/loader.service';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../../../../environments/environment';
import { MyStuffService } from '../../../../services/my-stuff.service';

@Component({
  selector: 'app-property-section',
  templateUrl: './property-section.component.html',
  styleUrls: ['./property-section.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class PropertySectionComponent implements OnInit {

  constructor(public popupService: PopupService, public propertyService: PropertyService, public myStuffService: MyStuffService) { }

  ngOnInit() {
    if(this.popupService.popupList.popups['my-stuff'] && !this.myStuffService.myStuffSectionOpened.allProperties) {
      this.propertyService.fetchPropertiesSource.next(true);
      this.myStuffService.myStuffSectionOpened.allProperties = true;
    }
  }

  ngAfterViewInit() {
    this.propertyService.addInputEventObservable();
  }

  paginate() {
    this.propertyService.fetchProperties();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/property-section/property-section.component.ts